// Wait until the DOM is fully loaded
document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.template-collection')) {
    // Select all elements with the class 'collection-discount-price-wrap'
    const discountElements = document.querySelectorAll('.collection-discount-price-wrap');
    const customerTags = document.querySelector('#collection-discount-price').getAttribute('data-customer-tags');
      let data = [];
      // Loop through each element
      discountElements.forEach(function (element) {
          // Get data attributes
          const productId = element.querySelector('#collection-discount-price').getAttribute('data-product-id');
          const variantIds = element.querySelector('#collection-discount-price').getAttribute('data-variant-ids');
          const productPrice = element.querySelector('#collection-discount-price').getAttribute('data-product-variant-price');
          const collectionIds = element.querySelector('#collection-discount-price').getAttribute('data-collection-ids');
          
  
          // Log data to the console (or handle it as needed)
          //console.log('Product ID:', productId);
          //console.log('Variant ID:', variantIds);
         // console.log('Product Price:', productPrice);
          //console.log('Collection IDs:', collectionIds);
  
          // Push data into the array in the desired format
          data.push({"variantIds":variantIds, "productId":productId, "collectionIds":collectionIds});
      });
    // Log the resulting data array to the console (or handle as needed)
    //console.log(data);
    dealerDiscount({"data": data, "customerTag": customerTags});
  }
});

// Function to send AJAX request
function dealerDiscount(data) {
    // API endpoint
     const apiUrl = 'https://mujtabam.sg-host.com/public/api/product-discount-collection';
     //const apiUrl = 'http://localhost:8000/api/product-discount-collection';
    // Perform AJAX request
    fetch(apiUrl, {
        method: 'POST', 
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Auth-Api-Key':'95f22e081e1b143052fe661fd163225b37f'
        },
       body: JSON.stringify(data)
    })
    .then(response => response.json()) // Parse JSON response
    .then(responseData => {
      // Handle the response data
      //console.log('Response:', responseData);
      if(responseData.success == true){
        Object.keys(responseData.data).forEach(productId => {
          const discountType = responseData.data[productId].discount_type;
          const discountValue = responseData.data[productId].discount_value;
          const discountCode = responseData.data[productId].discount_code;
          const quantity = document.querySelector(`.collection-product_variant_${productId} #collection-discount-price`).getAttribute('data-quantity'); 
          if(discountType == 'fixed_amount'){
            const product_price = document.querySelector(`.collection-product_variant_${productId} #collection-discount-price`).getAttribute('data-product-variant-price');
            const dealer_discount_price = Number(product_price)+(discountValue);
            document.querySelector(`.collection-product_variant_${productId} #collection-discount-price`).innerText = dealer_discount_price.toFixed(2);
            document.querySelector(`.collection-product_variant_${productId}`).style.display = 'block';            
          } else if(discountType == 'percentage'){
            // multiply (-) to covert negative value in positive
            const discount_value = discountValue * (-1);
            const product_price = Number(document.querySelector(`.collection-product_variant_${productId} #collection-discount-price`).getAttribute('data-product-variant-price'));
            const dealer_discount_price = product_price - ((product_price*(discount_value))/100);
            document.querySelector(`.collection-product_variant_${productId} #collection-discount-price`).innerText = dealer_discount_price.toFixed(2);
            document.querySelector(`.collection-product_variant_${productId}`).style.display = 'block';
          }
        });        
      } else {
        //document.querySelector(`.collection-product_variant_${productId}`).style.display = 'none';
        console.log('Response:', responseData.message);
      }
    })
    .catch(error => {
        console.error('Error:', error);
    });
}
